<template>
  <!--  个人订单详情-->
  <div v-loading="loading">
    <div v-for="(item,index) in dataList" :key="index" class="item" v-if="!loading">
      <div class="item-title">
        <div>凭证号: {{ item.INSURANCE_NO }}</div>
<!--        <div>: {{ item.COMPANY_NAME }}</div>-->
        <div>补偿科目: {{ item.CLAIM_CLASS_NAME }}</div>
        <div>补偿金额(元): {{ item.CLAIM_FEE }}</div>
        <div>挂科时间: {{ item.CLAIM_TIME }}</div>
        <div>申请日期: {{ formatDate(item.CREATE_TIME) }}</div>
        <div>处理日期: {{ formatDate(item.UPDATE_TIME) }}</div>
        <div>补偿状态:
          <!--        CLAIM_STATUS-->
          <van-tag type="primary" v-if="item.CLAIM_STATUS == '0'">待审核</van-tag>
          <van-tag type="primary" v-if="item.CLAIM_STATUS == '6'">待审核</van-tag>
          <van-tag type="success" v-if="item.CLAIM_STATUS == '1'">资料收集成功，案件复核中</van-tag>
          <van-tag type="success" v-if="item.CLAIM_STATUS == '2'">补偿中</van-tag>
          <van-tag type="success" v-if="item.CLAIM_STATUS == '3'">打款成功</van-tag>
          <van-tag type="danger" v-if="item.CLAIM_STATUS == '7'">审核驳回</van-tag>
          <van-tag type="danger" v-if="item.CLAIM_STATUS == '9'">审核拒绝</van-tag>
          <van-tag type="danger" v-if="item.CLAIM_STATUS == '12'">打款失败</van-tag>
          <van-tag type="success" v-if="item.CLAIM_STATUS == '20'">已报案</van-tag>
        </div>
        <div>备注: {{ item.CLAIM_STATUS == '1'?"资料初审已通过，待复核通过后打款" :item.CLAIM_REFUSE}}</div>
        <div v-if="item.jjid != ''  &&item.jjid != null">加急状态: <van-tag type="success">{{ item.jjlx }}</van-tag></div>
        <div v-if="(  item.CLAIM_STATUS == '1'  ) && (item.jjid == ''  || item.jjid == null) && isDict == 1">
          <van-button style="width: 100%;" size="large" type="danger" @click="openFormEvent(item)">加急</van-button>
        </div>
      </div>
      <van-popup v-model="openForm" position="bottom" :style="{ height: '50%' }" :close-on-click-overlay="false">
        <van-form>
          <van-field
            :value="jjType"
            name="加急类型"
            label="加急类型"
            readonly
            clickable
            placeholder="请输入选择加急类型"
            @click="showPicker = true"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="sysDictList"
              value-key="dictName"
              @cancel="showPicker = false"
              @confirm="onConfirm"
            />
          </van-popup>
          <van-field
            :value="jjbj"
            name="加急比例(%)"
            label="加急比例(%)"
            readonly
          />
          <van-field
            :value="jjje"
            name="服务费(元)"
            label="服务费(元)"
            readonly
          />
          <van-field
            :value="paymentValue"
            name="支付方式"
            label="支付方式"
            readonly
            clickable
            placeholder="请输入选择加急类型"
            @click="paymentTypeOpen = true"
          />
          <van-popup v-model="paymentTypeOpen" position="bottom">
            <van-picker
              show-toolbar
              :columns="[
                {name:'支付宝',value:'ALP'},
                {name:'微信',value:'WXP'}
              ]"
              value-key="name"
              @cancel="paymentTypeOpen = false"
              @confirm="paymentBtn"
            />
          </van-popup>
          <div class="sign">
            <a href="javascript:void(0)" class="btn"  @click="gotoSign"> 手写签名</a>
          </div>
          <p class="protocol">
<!--            <van-checkbox v-model="checked"  @change="readBook"  icon-size="18px">我已阅读 <i @click.stop="openProtocol">《个人信息使用授权书》</i>并同意授权-->
<!--            </van-checkbox>-->
            <van-checkbox v-model="checked"  @change="readBook"  icon-size="18px">同意
            </van-checkbox>
          </p>
          <div style="margin: 16px;display: flex" >
            <van-button style="width: 30%;margin: 0px 10%"  round block type="info" @click="closePop">取消</van-button>
            <van-button style="width: 30%;margin: 0px 10%" round block type="primary" @click="saveInfo">提交</van-button>
          </div>
        </van-form>
      </van-popup>
      <van-dialog v-model:show="signShow" title="手写签名" :show-cancel-button="false" :showConfirmButton="false" :width="isPhone?'100%':'900px'" :style="{top:isPhone?'50%':''}">
        <signer @set-sign="setSign"></signer>
      </van-dialog>
      <van-dialog v-if="openImg" v-model="openImg" :title="`请使用${openImgTitle}扫码支付`" show-cancel-button>
        <van-image v-if="openImg" :src="paymentUrl" style="width: 80%;margin: 20px 10% 20px 10%" />
      </van-dialog>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import {Tag, Popup, Form, Field, Button, Cell, Picker,Toast,Image} from 'vant';
import {Config} from "../common/api";
import signer from '../sign/signer_jj';
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(Cell);
Vue.use(Tag);
Vue.use(Toast);
Vue.use(Image);
export default {
  name: 'myInfo',
  props: {
    certNo: null
  },
  components:{
    signer
  },
  data() {
    return {
      isDict:0,
      dataList: [],
      loading: true,
      openForm: false,
      sysDictList: [],
      claimId:'',
      checked: false, // 勾选协议
      jjType: '',
      jjje: 0.00,
      jjbj: '',
      jjid: '',
      showPicker: false,
      isPhone:true,
      signShow:false,
      paymentType:'',
      userName:'',
      cerId:'',
      claimMoney: 0.00,
      signUrl:'',
      paymentUrl:'',
      paymentTypeOpen:false,
      openImg:false,
      openImgTitle:'',
      paymentValue:''
    }
  },
  mounted() {
    this.initInfo();
    this.getSysDict();
    // 定义正则表达式进行匹配
    var isMobileRegex = /(Android|iPhone|SymbianOS|Windows Phone)/i;
    var userAgent = navigator.userAgent;
    if (isMobileRegex.test(userAgent)) {
      console.log("这是移动设备"); // PC端输出"这是移动设备"
    } else {
      console.log("这是PC端"); // 移动端输出"这是PC端"
      this.isPhone = false
    }
  },
  methods: {
    saveInfo(){
      if (this.jjType == null || this.jjType == ''){
        //请输入加急
        Toast.fail('请选择加急方式!');
        return;
      }
      if (this.signUrl == null || this.signUrl == '' ){
        //请输入加急
        Toast.fail('请签名!');
        return;
      }
      if (this.paymentType == null || this.paymentType == '' ){
        //请输入加急
        Toast.fail('请选择支付方式!');
        return;
      }
      let self = this
      this.$ajax({
        method: "post",
        url: Config.api_url + "applets-server/api/payment/save",
        withCredentials: false,
        data: {
          money: self.jjje,
          claimId: self.claimId,
          type: self.paymentType,
          userName:self.userName,
          cerId:self.cerId,
          jjId:self.jjid,
          signUrl:self.signUrl

        },
        headers: {'Content-Type': 'application/json'}
      }).then(function (res) {
        if (res.data.success == true){
          self.paymentUrl = res.data.data
          console.log(self.paymentUrl)
          self.closePop();
          self.openImg = true
        }else{

        }

      })
    },
    openProtocol() {
      // this.$refs.maskShow.maskFlag = true;
      // this.protocolDetailFlag = true;
    },
    readBook(val){
      if(val){
        this.gotoSign();
      }
    },
    gotoSign(){
      this.signShow = true;

    },
    setSign(signUrl){
      this.signUrl = signUrl;
      this.signShow = false;
    },
    onConfirm(value, index) {
      console.log("value",value)
      this.jjType = value.dictName;
      this.jjbj = value.dictValue;
      this.jjid = value.id;
      this.jjje = this.claimMoney * 1.00 * (parseFloat(value.dictValue) * 1.00 / 100)
      this.showPicker = false
    },
    paymentBtn(v){
      this.paymentType = v.value
      this.paymentValue = v.name
      this.openImgTitle = v.name
      this.paymentTypeOpen = false
    },

    initInfo() {
      let self = this
      this.$ajax({
        method: "get",
        url: Config.api_url + "applets-server/api/policy/myInfo",
        withCredentials: false,
        params: {
          certId: this.certNo,
        },
        headers: {'Content-Type': 'application/json'}
      }).then(function (res) {
        self.dataList = res.data.data
        self.loading = false
      })
      this.$ajax({
        method: "get",
        url: Config.api_url + "applets-server/api/dict/getDict",
        headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')}
      }).then(function (res) {
        self.isDict = res.data.data
        console.log("self.isDict",self.isDict)
      })
    },
    //获取加急费用
    getSysDict() {
      let self = this;
      this.$ajax({
        method: "get",
        url: Config.api_url + "applets-server/api/dict/getDictList",
        withCredentials: false,
        params: {
          certId: this.certNo,
        },
        headers: {'Content-Type': 'application/json'}
      }).then(function (res) {
        self.sysDictList = res.data.data

      })
    },
    formatDate(value) {
      const date = new Date(value);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      const seconds = ('0' + date.getSeconds()).slice(-2);
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    openFormEvent(item) {
      console.log(item)
      this.claimId = item.CLAIM_ID
      this.cerId = item.CERT_ID
      this.userName = item.NAME
      this.claimMoney = parseFloat(item.CLAIM_FEE)
      this.closePop()
      this.openForm = true
    },
    closePop(){
      this.jjType = ''
      this.jjje = 0.00
      this.jjbj = ''
      this.jjid = ''
      this.showPicker = false
      this.openForm = false
      this.checked = false
      this.signUrl = ""
      this.paymentValue = ""
    }

  }
}
</script>
<style scoped>
.item {
  margin: 10px;
  padding: 10px;

  /*font-size: 12px;*/
  background-color: #FFF;
  border: 1px solid #beb8b8;
  /* 水平偏移 垂直偏移 模糊半径 扩散半径 颜色 */
  box-shadow: 1px 1px 2px 0px rgba(190, 164, 164, 0.5);
}

.item-title {
}
</style>



// WEBPACK FOOTER //
// myInfo.vue?2b1b1578